import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import withAuth from '../../components/withAuth';
import { Card } from '@material-ui/core';
import { loadComponent } from '../../redux/componentsPark/componentsParkActions';
import TableWithPagination from '../../components/Table/TableWithPagination';


class Park extends Component {

    constructor(props) {
        super(props);

        if (!props.currentPark)
            props.history.push("/parks");

        this.state = {
            columns: [
                {
                    columns: [
                        {
                            Header: "Nom",
                            minWidth: 150,
                            width: 400,
                            accessor: "complete_name",
                        },
                        {
                            Header: "Votre référence",
                            width: 150,
                            accessor: "customer_ref",
                        },
                        {
                            Header: "Date de mise en service",
                            width: 100,
                            accessor: "commissioning_date",
                        },
                        {
                            Header: "Attributs",
                            minWidth: 200,
                            accessor: "attributes_description",
                        },
                    ]
                },
            ]
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.history.push("/parks");
    }

    loadComponent(park) {
        this.props.loadComponent(park, () => this.props.history.push("/parks/park/componentPark"));
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: this.loadComponent.bind(this, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    render() {
        if (!this.props.currentPark)
            return null;

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
                    <Card>
                        <TableWithPagination
                            data={this.props.currentPark.component_ids}
                            columns={this.state.columns}
                            getTrProps={this.getTableTrProps.bind(this)} />
                    </Card>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        currentPark: state.componentsPark.currentPark,
        activeUser: state.activeUser,
        sites: state.sites,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        loadComponent: (component, onSuccess) => dispatch(loadComponent(component, onSuccess)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(Park);
